import h from './h';
import { Img } from './img';
import Hint from './hint';
import Tab from './tab';
import TabList from './tabList';
import File from './file';
import PageRef from './pageRef';
import { IconNo, IconYes } from './icons';
import { pre, code } from './code';
import Video from './video';

const components = {
  h1: ({ children }) => h(children, 1),
  h2: ({ children }) => h(children, 2),
  h3: ({ children }) => h(children, 3),
  h4: ({ children }) => h(children, 4),
  h5: ({ children }) => h(children, 5),
  h6: ({ children }) => h(children, 6),
  img: Img,
  Hint,
  TabList,
  Tab,
  File,
  PageRef,
  code,
  pre,
  IconNo,
  IconYes,
  Video
};

export default components;
